import { useI18N } from "@sundae/react-hooks";
import { AvatarGroup, Balance, Notice, Text } from "@sundae/ui-toolkit";
import { AssetAmount } from "@sundaeswap/asset";
import { SundaeUtils } from "@sundaeswap/core/utilities";
import { FC, memo } from "react";
import AssetAvatar from "../../../../components/AssetAvatar";
import { useAppContext, useProfileAppContext } from "../../../../stores";
import { useZapContext } from "../../../../stores/LiquidityContext/ZapContext/context";
import { numberI18n } from "../../../../utils/number-format";
import { getPoolName } from "../../../../utils/pool.utils";
import BalanceWithAssetName from "../../../BalanceWithAssetName";

const ZapOutput: FC = () => {
  const { currentLocale, t } = useI18N("liquidity");
  const {
    state: { privacyEnabled },
  } = useProfileAppContext();
  const {
    state: { activeZapPool },
  } = useAppContext();
  const {
    derived: { zapAssetAmount },
    state: { liquidity },
  } = useZapContext();

  if (activeZapPool && zapAssetAmount && liquidity) {
    return (
      <>
        {/* -------------------------------------------------------------------------------------------------
         * Output Amounts
         * -----------------------------------------------------------------------------------------------*/}
        <div className="z-10 flex flex-wrap gap-2">
          <Text className="text-center" tag="div" size="2xl">
            {t("zap.confirm.output.youWillZap")}
          </Text>
          {SundaeUtils.isAdaAsset(zapAssetAmount.metadata) ? (
            <Balance
              abbreviate={false}
              gradient
              locale={currentLocale}
              privacy={privacyEnabled}
              showSymbol={SundaeUtils.isAdaAsset(zapAssetAmount.metadata)}
              size="2xl"
              value={zapAssetAmount}
            />
          ) : (
            <BalanceWithAssetName
              asset={zapAssetAmount.metadata}
              abbreviate={false}
              className="!gap-1.5"
              gradient
              locale={currentLocale}
              privacy={privacyEnabled}
              showSymbol={false}
              size="2xl"
              value={zapAssetAmount}
            />
          )}

          <Text className="text-center" tag="div" size="2xl">
            {t("for", { ns: "glossary" })}
          </Text>
          <Balance
            abbreviate={false}
            gradient
            locale={currentLocale}
            privacy={privacyEnabled}
            showSymbol={false}
            size="2xl"
            value={new AssetAmount(liquidity?.generatedLp)}
          />
          <AvatarGroup>
            <AssetAvatar asset={activeZapPool.assetA} size="lg" stacked />
            <AssetAvatar asset={activeZapPool.assetB} size="lg" stacked />
          </AvatarGroup>

          <Text tag="div" size="2xl">
            {t("confirmationModal.assets", {
              assets: getPoolName({ assetA: activeZapPool.assetA, assetB: activeZapPool.assetB }),
              count: Number(liquidity.generatedLp),
            })}
          </Text>
        </div>

        {/* -------------------------------------------------------------------------------------------------
         * Estimated Output Warning
         * -----------------------------------------------------------------------------------------------*/}
        <Notice type="info" size="xs" title={t("outputEstimate", { ns: "common" })}>
          {t("confirmationModal.message", {
            amount: numberI18n(liquidity.generatedLp, {}, currentLocale),
            count: Number(liquidity.generatedLp),
          })}
        </Notice>
      </>
    );
  }

  return null;
};

export default memo(ZapOutput);
